import * as React from 'react';

import { DimeButton } from './DimeButton.js';
import { DimeTooltip } from './DimeTooltip.js';

/** One icon action in a card shell's header; `label` is its tooltip and accessible name. */
export type CardShellAction = Readonly<{
  icon: React.ReactElement<{ className?: string; 'aria-hidden'?: boolean }>;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
}>;

/** A card shell's header actions as ghost icon buttons, each named and tooltipped by its label. */
export function CardShellActionButtons({
  actions,
}: Readonly<{ actions: readonly CardShellAction[] }>) {
  return actions.map((action) => {
    const button = (
      <DimeButton
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={action.label}
        onClick={action.onClick}
        disabled={action.disabled}
        disabledTooltip={action.disabledTooltip ?? action.label}
      >
        {React.cloneElement(action.icon, { 'aria-hidden': true })}
      </DimeButton>
    );
    return action.disabled ? (
      <React.Fragment key={action.label}>{button}</React.Fragment>
    ) : (
      <DimeTooltip key={action.label} content={action.label}>
        {button}
      </DimeTooltip>
    );
  });
}
